import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Dollar = ({ color, ...props }: IconProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_2645_29135)">
                <path
                    d="M5.80556 15.4444H15.7361C15.9755 15.4444 16.2052 15.3493 16.3745 15.18C16.5438 15.0107 16.6389 14.7811 16.6389 14.5417C16.6389 14.3022 16.5438 14.0726 16.3745 13.9033C16.2052 13.734 15.9755 13.6389 15.7361 13.6389H8.51389C7.31673 13.6389 6.16861 13.1633 5.32209 12.3168C4.47557 11.4703 4 10.3222 4 9.125C4 7.92784 4.47557 6.77972 5.32209 5.9332C6.16861 5.08668 7.31673 4.61111 8.51389 4.61111H10.3194V1H13.9306V4.61111H18.4444V8.22222H8.51389C8.27446 8.22222 8.04483 8.31734 7.87553 8.48664C7.70622 8.65594 7.61111 8.88557 7.61111 9.125C7.61111 9.36443 7.70622 9.59406 7.87553 9.76336C8.04483 9.93267 8.27446 10.0278 8.51389 10.0278H15.7361C16.9333 10.0278 18.0814 10.5033 18.9279 11.3499C19.7744 12.1964 20.25 13.3445 20.25 14.5417C20.25 15.7388 19.7744 16.887 18.9279 17.7335C18.0814 18.58 16.9333 19.0556 15.7361 19.0556H13.9306V22.6667H10.3194V19.0556H5.80556V15.4444Z"
                    fill={color || "#000"}
                />
            </g>
            <defs>
                <clipPath id="clip0_2645_29135">
                    <rect width="24" height="24" fill={color || "#000"} />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Dollar
